export default __webpack_public_path__ + "images/a59862c18c2e81f837b25c3c80fe0313.svg";